var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1518 10.8995L12.1361 19.9151C10.0859 21.9653 6.76177 21.9653 4.71152 19.9151C2.66126 17.8648 2.66127 14.5407 4.71152 12.4904L13.7271 3.47483C15.094 2.108 17.31 2.108 18.6769 3.47483C20.0437 4.84167 20.0437 7.05775 18.6769 8.42458L10.0148 17.0866C9.3314 17.7701 8.22336 17.7701 7.53994 17.0866C6.85653 16.4032 6.85653 15.2952 7.53994 14.6118L15.1413 7.01037",
    stroke: "#5D6675",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment01);
export default __webpack_public_path__ + "static/media/attachment-01.ef71eec40e6b17c6b24ca4cd488ff51f.svg";
export { ForwardRef as ReactComponent };